module.exports = __webpack_public_path__ + "static/media/anim-2-add.e1c31589.png";